export const proc = {
  check : 1,  // 確認
  set   : 2   // 登録
}

export const userflag = {
  general : "0",
  member : "1",
  vip : "2"
}

// 来場予定URL
export const exhibitioninfo: string[] = [
  'exhibition', // 来場予定
  'lang', // 言語
];

// パスワード再設定URL
export const emailinfo: string[] = [
  'email', // 来場予定
  'lang', // 言語
];

// 言語設定
export const langList: string[] = [
  'ja',
  'en',
  'cn'
];